import AddressTypes from 'common/Forms/AddressTypes';
import { ConcatAddressLine, GetCommonWFormWellFormedAddress, GetCommonWFormFieldPathValueMap, CheckValidPostalCodeAndLine3And4Combination } from 'common/Addresses/AddressFormatters/Shared/AddressFormatHelper';

function GetBusinessAddressFieldPathValueMap(addressPath, wellFormedAddress) {
  const validPostalCodeAndLine3And4Combination = CheckValidPostalCodeAndLine3And4Combination(wellFormedAddress?.addressPostalCode, wellFormedAddress?.addressLine3, wellFormedAddress?.addressLine4);

  const fieldPathValueDictionary = [
    { key: `${ addressPath }.street`, value: ConcatAddressLine([wellFormedAddress?.addressLine1, wellFormedAddress?.addressLine2]) },
    { key: `${ addressPath }.cityCountyStateProvince`, value: ConcatAddressLine([wellFormedAddress?.addressLine3, wellFormedAddress?.addressLine4, wellFormedAddress?.addressPostalCode], validPostalCodeAndLine3And4Combination) },
  ];

  return fieldPathValueDictionary;
}

function GetWellFormedBusinessAddress(formAddress) {
  const wellFormedAddress = {
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    postalCode: '',
    country: 'US'
  };

  const splitLine1 = formAddress?.street?.split(',')?.map(x => x.trim())?.reverse() ?? ['', ''];
  const splitLine2 = formAddress?.cityCountyStateProvince?.split(',')?.map(x => x.trim())?.reverse() ?? ['', '', ''];

  if (splitLine1.length >= 2) {
    [wellFormedAddress.line2, ...wellFormedAddress.line1] = splitLine1;
  } else {
    [...wellFormedAddress.line1] = splitLine1;
  }

  if (splitLine2.length >= 3) {
    [wellFormedAddress.postalCode, wellFormedAddress.line4, ...wellFormedAddress.line3] = splitLine2;
  } else if (splitLine2.length === 2) {
    [wellFormedAddress.line4, ...wellFormedAddress.line3] = splitLine2;
  } else {
    [...wellFormedAddress.line3] = splitLine2;
  }

  wellFormedAddress.line1 = wellFormedAddress.line1.reverse().join(', ');
  wellFormedAddress.line3 = wellFormedAddress.line3.reverse().join(', ');

  return wellFormedAddress;
}

export function GetFieldPathValueMap(addressProps, wellFormedAddress) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
      return GetCommonWFormFieldPathValueMap('part1.permanentAddress', wellFormedAddress);
    case AddressTypes.Business:
      return GetBusinessAddressFieldPathValueMap('part1.businessAddress', wellFormedAddress);
    default:
      break;
  }
}

export function GetWellFormedAddress(addressProps, addressValues) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
      return GetCommonWFormWellFormedAddress(addressValues?.part1?.permanentAddress);
    case AddressTypes.Business:
      return GetWellFormedBusinessAddress(addressValues?.part1?.businessAddress);
    default:
      break;
  }
}

export function GetW8Eci2014FieldPathValueMap(addressProps, wellFormedAddress) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
      return GetCommonWFormFieldPathValueMap('part1.permanentAddress', wellFormedAddress);
    case AddressTypes.BusinessEci2014:
      return GetCommonWFormFieldPathValueMap('part1.businessAddress', wellFormedAddress);
    default:
      break;
  }
}

export function GetW8Eci2014WellFormedAddress(addressProps, addressValues) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
      return GetCommonWFormWellFormedAddress(addressValues?.part1?.permanentAddress);
    case AddressTypes.BusinessEci2014:
      return GetCommonWFormWellFormedAddress(addressValues?.part1?.businessAddress);
    default:
      break;
  }
}
